import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_URL ?? '/api/admin',
  headers: { 'Content-Type': 'application/json' },
})

// Adjuntar token en cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// En 401 → limpiar sesión y redirigir al login (excepto en el propio endpoint de login)
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const isLoginEndpoint = error.config?.url?.includes('/auth/login')
    if (error.response?.status === 401 && !isLoginEndpoint) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      window.location.href = '/backoffice/login'
    }
    return Promise.reject(error)
  }
)

export default api
